import React, { Component } from "react";
import { Input, Button, Form, Modal, Card, Col, Row,message,Image } from "antd";
import axios from 'axios'
import { strings } from 'res';

export class Tampilan extends Component {

    constructor(props){
        super(props)
        this.state = {
          homePageInd:{},
          homePageEng:{},
          visible: false,
          updateMessage:"",
          upload:{
            name: 'file',
            action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            headers: {
              authorization: 'authorization-text',
            },
            maxSize:1000000,
            onChange(info) {
              if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
              }
              if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
              } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
              }
            }
          }
        }
        this.handleChange = this.handleChange.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk = this.handleOk.bind(this);
      }
    
      showModal = () => {
        this.setState({
          visible: true,
        });
      };
    
      handleCancel = e => {
        console.log(e);
        this.setState({
          visible: false,
        });
      };
    
      handleOk = e => {
        console.log(e);
        this.setState({
          visible: false,
        });
      };
    
      componentDidMount(){
        axios.get(`${strings.url.content_url}/resourcesPage/read`, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin":"*"
          }
        }).then(doc=>{
            this.setState({
                homePageInd:doc.data.resourcesInd[0]
              })
        })
        axios.get(`${strings.url.content_url}/resourcesPage/read`, {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin":"*"
            }
          }).then(doc=>{
              this.setState({
                  homePageEng:doc.data.resourcesEng[0]
                })
          })
      }
    
      handleChange(event){
        this.setState({
          homePageInd:{
            ...this.state.homePageInd,
            [event.target.name]: event.target.value
           },
           homePageEng:{
            ...this.state.homePageEng,
            [event.target.name]: event.target.value
           },
        })
        console.log(this.state.homePageInd)
      }
    
       onFinish = (values) =>{
        axios.post(`${strings.url.content_url}/resourcesPage/updateIndonesia`,this.state.homePageInd, {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin":"*"
            }
          }).then(doc=>{
            console.log(doc)
            this.setState({
              visible: true,
              updateMessage:doc.data.msg
            });
          })
          axios.post(`${strings.url.content_url}/resourcesPage/updateEnglish`,this.state.homePageEng, {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin":"*"
            }
          }).then(doc=>{
            console.log(doc)
            this.setState({
              visible: true,
              updateMessage:doc.data.msg
            });
          })
      }

    render() {
        return (
            <div >
                 <Modal
                        title="Message!"
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                    >
                        <h3 style={{textAlign:"center"}}>{this.state.updateMessage}</h3>
                    </Modal>
                <h1 style={{textAlign:"center"}}>Resources Page Structure</h1>
                <Card style={{ height: "100%" }}>
                    <Card>
                        <Row >
                            <h3 style={{textAlign:"center"}}>Navigation</h3>
                        </Row>
                    </Card>
                    <Card>
                        <Row style={{textAlign:"center"}}>
                            <h3 >Jumbotron</h3>
                        </Row>
                        <Row gutter={24} style={{textAlign:"center"}}>
                            <Col sm={8}>
                                Publications
                            </Col>
                            <Col sm={8}>
                                Manuals
                            </Col>
                            <Col sm={8}>
                                Newsletters
                            </Col>
                        </Row>
                    </Card>
                    <Card>
                        <Row >
                            <h3 style={{textAlign:"center"}}>Subscribe to Our Newsletters</h3>
                        </Row>
                        <Row gutter={24}>
                           <Col sm={24}>
                                <Card >
                                    <p>1 x 5 Inputs Section</p>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                    <Card>
                        <Row >
                            <h3 style={{textAlign:"center"}}>Publications</h3>
                        </Row>
                        <Row>
                            <p>Publications Desc</p>
                        </Row>
                    </Card>
                    <Card>
                        <Row >
                            <h3 style={{textAlign:"center"}}>Manuals</h3>
                        </Row>
                        <Row>
                            <p>Manuals Desc</p>
                        </Row>
                    </Card>
                    <Card>
                        <Row >
                            <h3 style={{textAlign:"center"}}>Newsletters</h3>
                        </Row>
                        <Row>
                            <p>Newsletters Desc</p>
                        </Row>
                    </Card>
                    <Card>
                        <Row >
                            <h3 style={{textAlign:"center"}}>Stakeholders Section</h3>
                        </Row>
                    </Card>
                    <Card>
                        <Row >
                            <h3 style={{textAlign:"center"}}>Footer</h3>
                        </Row>
                    </Card>
                </Card>
                <h1>Images</h1>
                <Card style={{ height: "100%" }}>
                <Form onFinish={this.onFinish} >  
                    <label>Jumbotron</label>
                    <Input onChange={this.handleChange} value={this.state.homePageInd.image_1} name="image_1" placeholder="Image - 1" />
                    <br />
                    <br />
                    <Image style={{width:"50px",height:"50px"}} src={this.state.homePageInd.image_1}></Image>
                    <br />
                    <br />
                    <label>Publications</label>
                    <Input onChange={this.handleChange} value={this.state.homePageInd.image_2} name="image_2" placeholder="Image - 2" />
                    <br />
                    <br />
                    <Image style={{width:"50px",height:"50px"}} src={this.state.homePageInd.image_2}></Image>
                    <br />
                    <br />
                    <label>Manuals</label>
                    <Input onChange={this.handleChange} value={this.state.homePageInd.image_3} name="image_3" placeholder="Image - 3" />
                    <br />
                    <br />
                    <Image style={{width:"50px",height:"50px"}} src={this.state.homePageInd.image_3}></Image>
                    <br />
                    <br />
                    <label>Newsletters</label>
                    <Input onChange={this.handleChange} value={this.state.homePageInd.image_4} name="image_4" placeholder="Image - 4" />
                    <br />
                    <br />
                    <Image style={{width:"50px",height:"50px"}} src={this.state.homePageInd.image_4}></Image>
                    <br />
                    <br />
                    <Form.Item >
                        <Button htmlType="submit" type="primary" style={{width:"100%"}} >Submit</Button>
                    </Form.Item>
                </Form>
                </Card>
            </div>
        );
    }
}

export default Tampilan;
